module.exports = __webpack_public_path__ + "static/popup-desktop-b286ca69ef348f42cf6209e6f1d4400b.svg";